





import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({})
export default class OidcCallback extends Vue {
	public created() {
		this.$store.dispatch('oidc/oidcSignInCallback')
			.then((redirect) => this.$router.push(redirect))
			.catch((err) => this.$router.push('/signin-oidc-error'));
	}
}
